import {
  Ahs2024LogoColor,
  Hbw210LogoColor,
  HsaLogoColor,
} from '@ftdr/blueprint-components-react'
import React from 'react'
import { useScrolledContext } from 'src/hooks/use-isScrolled-context'
import { generateDataByBrand } from 'src/utils/tenant-helper'
interface IProps {
  isDesktop: boolean | undefined
}
const Logo: React.FC<IProps> = ({ isDesktop }) => {
  const { isScrolled } = useScrolledContext()

  return generateDataByBrand([
    <Ahs2024LogoColor
      data-testid="logo"
      className="transition-all"
      height={!isScrolled ? 50 : 24}
      width={!isScrolled ? 150 : 72}
    />,
    isDesktop ? (
      <HsaLogoColor
        data-testid="logo"
        className="transition-all"
        height={!isScrolled ? 50 : 24}
        width={!isScrolled ? 150 : 72}
      />
    ) : (
      <HsaLogoColor
        data-testid="logo"
        className="transition-all"
        height={!isScrolled ? 40 : 20}
        width={!isScrolled ? 120 : 60}
      />
    ),
    <Hbw210LogoColor
      data-testid="logo"
      className="transition-all"
      height={!isScrolled ? 50 : 24}
      width={!isScrolled ? 150 : 72}
    />,
  ])
}

export default Logo
